import { render, staticRenderFns } from "./contatosRenovacaoSidebar.vue?vue&type=template&id=6038bc96"
import script from "./contatosRenovacaoSidebar.vue?vue&type=script&lang=js"
export * from "./contatosRenovacaoSidebar.vue?vue&type=script&lang=js"
import style0 from "./contatosRenovacaoSidebar.vue?vue&type=style&index=0&id=6038bc96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports